<template>
  <v-dialog v-model="show" persistent max-width="400">
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text class="py-0 my-0">
        <v-alert dense text :type="alertType">
          {{message}}
        </v-alert>
          <v-select
            v-model="selectedSelect"
            v-if="select.values"
            :items="select.values"
            :label="select.label"
            :item-text="select.text"
            autocomplete="off"
            return-object
          ></v-select>
      </v-card-text>
      <v-card-actions class="d-flex justify-end px-4 pb-4">
        <v-btn class="ma-2" v-if="isConfirm()" @click="onCancel()">{{cancelBtnLabel}}</v-btn>
        <v-btn color="blue-grey" class="ma-2 white--text" @click="onOk()">{{okBtnLabel}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Title"
    },
    message: {
      type: String,
      default: "Confirm?"
    },
    select: {
      type: Object,
      default: () => ({})
    },
    dialogType: {
      type: String,
      default: "confirm"
    },
    alertType: {
      type: String,
      default: "info"
    },
    okBtnLabel: {
      type: String,
      default: "OK"
    },
    cancelBtnLabel: {
      type: String,
      default: "Cancel"
    },
    object: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    selectedSelect: undefined,
  }),
  methods: {
    isConfirm() {
      return this.dialogType === "confirm";
    },
    onCancel() {
      this.$emit("onCancel", {object: this.object});
      this.$emit("update:show", false);
    },
    onOk() {
      const ret = {object: this.object};
      if (this.select.values) {
        const selected = this.selectedSelect;
        if (this.select.required && !selected) {
          return;
        }
        ret["select"] = selected;
      }
      this.$emit("onOk", ret);
      this.$emit("update:show", false);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>